import { useState } from 'react';
import { motion } from 'framer-motion';
import { MarketingNav, BackToTop } from '../components/ui/MarketingNav';
import { SiteFooter } from './AboutPage';

const FAQS = [
  {
    q: 'Cine suntem?',
    a: 'Suntem 3 prieteni care vor să ofere evenimentelor speciale din viața oamenilor o altă perspectivă, o perspectivă care de multe ori este lăsată pe mâna unui fotograf care nu poate fi în toate locurile în același timp, dar invitații pot.',
  },
  {
    q: 'De ce GuestLens și nu altă aplicație?',
    a: 'Noi nu încercăm să atragem clienți prin aspectul site-ului sau reclame cu „celebrități" care să promoveze o aplicație pe care nici măcar nu o folosesc. Noi atragem clienții prin calitatea superioară a produsului pe care îl oferim și simplitatea acestuia. Noi nu impunem un spațiu de stocare limitat, nu impunem un termen limită în care clientul trebuie să-și descarce pozele pe dispozitiv astfel că dispar pentru totdeauna.',
  },
  {
    q: 'Ce aducem în plus față de competitori?',
    a: 'O interfață „beginner-friendly" pentru încărcarea amintirilor. Nu complicăm ce nu trebuie să fie complicat. Support în mai puțin de 24h (dacă este cazul în ziua nunții, oferim support în aceeași zi). Support oferit de o persoană reală, nu de un bot limitat să răspundă doar la întrebări setate de programator.',
  },
  {
    q: 'Cum funcționează?',
    a: 'Primești un cod QR personalizat pe care îl printezi în funcție de câte mese ai la eveniment. Plasezi codul QR pe fiecare masă și informezi invitații de GuestLens. Încărcarea pozelor durează mai puțin de 15 secunde de la accesarea codului QR. Invitații sunt automat redirecționați către link-ul tău personalizat de la eveniment.',
  },
  {
    q: 'Dar confidențialitatea?',
    a: 'Link-ul este personalizat doar pentru tine și pentru invitații evenimentului, nu va fi folosit pentru „reclamă" pe site sau oriunde altundeva. Tu decizi cine vede pozele și cine nu, nu noi.',
  },
  {
    q: 'Am nevoie de cont?',
    a: 'Nu, nu este nevoie de cont. Codul QR este doar scanat și încărcarea pozelor poate începe.',
  },
] as const;

export default function FAQPage() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <div className="min-h-screen">
      <MarketingNav />

      {/* ─── Hero ─── */}
      <section className="container-page relative pb-3xl pt-lg">
        <div className="mx-auto max-w-3xl text-center">
          <p className="kicker justify-center">Întrebări frecvente</p>
          <h1
            className="mt-sm font-serif"
            style={{ fontVariationSettings: "'opsz' 144", fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}
          >
            Șase întrebări
            <br />
            <em className="italic text-fg-soft">pe care le auzim des.</em>
          </h1>
          <p className="mt-md text-fg-soft">
            Dacă nu găsești ce cauți aici, scrie-ne la{' '}
            <a href="mailto:guestlens.events@gmail.com" className="text-accent hover:underline">
              guestlens.events@gmail.com
            </a>
            . Răspundem în aceeași zi, de obicei în aceeași oră.
          </p>
        </div>
      </section>

      {/* ─── FAQ list ─── */}
      <section className="container-page pb-4xl">
        <div className="mx-auto max-w-3xl">
          <ol className="border-t border-border">
            {FAQS.map((item, i) => {
              const isOpen = openIdx === i;
              return (
                <motion.li
                  key={i}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: '-50px' }}
                  transition={{ delay: i * 0.05, duration: 0.6 }}
                  className="border-b border-border"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${i}`}
                    className="flex w-full items-baseline justify-between gap-md py-lg text-left"
                  >
                    <div className="flex items-baseline gap-md">
                      <span className="font-mono text-xs uppercase tracking-[0.22em] text-fg-soft">
                        0{i + 1}
                      </span>
                      <span
                        className="font-serif text-2xl leading-[1.1] tracking-tight text-fg"
                        style={{ fontVariationSettings: "'opsz' 144" }}
                      >
                        {item.q}
                      </span>
                    </div>
                    <span
                      aria-hidden
                      className="shrink-0 text-2xl leading-none text-fg-soft transition-transform duration-300"
                      style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
                    >
                      +
                    </span>
                  </button>

                  <motion.div
                    id={`faq-panel-${i}`}
                    initial={false}
                    animate={{
                      height: isOpen ? 'auto' : 0,
                      opacity: isOpen ? 1 : 0,
                    }}
                    transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-lg pl-7 pr-12 text-fg-soft">{item.a}</p>
                  </motion.div>
                </motion.li>
              );
            })}
          </ol>

          <div className="mt-2xl flex flex-col items-center gap-sm text-center">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-fg-soft">
              Nu ți-am răspuns la ce te interesează?
            </p>
            <a
              href="mailto:guestlens.events@gmail.com"
              className="font-serif text-2xl text-fg hover:text-accent"
              style={{ fontVariationSettings: "'opsz' 144" }}
            >
              Scrie-ne direct →
            </a>
          </div>
        </div>
      </section>

      <SiteFooter />
      <BackToTop />
    </div>
  );
}
